import { render, staticRenderFns } from "./OvertimeReview.vue?vue&type=template&id=8dee4962&scoped=true"
import script from "./OvertimeReview.vue?vue&type=script&lang=js"
export * from "./OvertimeReview.vue?vue&type=script&lang=js"
import style0 from "./OvertimeReview.vue?vue&type=style&index=0&id=8dee4962&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dee4962",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VDataTable,VDatePicker,VMenu,VPagination,VTextField})
